export default function getPlanId() {
  return window?.DP_SUBSCRIPTION;
}
